/* The Maison Kettle Co. shared theme script (port of the prototype's assets/maison.js, shared parts only).
   window.MK     helpers: $, $$, esc, inr, money, config, reveal, track
   window.MKP    pricing preview (the real prices are Shopify variants)
   window.MKBag  the cart drawer: add(items, opts), open(), close(), refresh(), gift(on)
   Page-specific logic (product page, filters, homepage tin, carousels) lives with each page's section. */
(function () {
  if (/static/.test(location.search)) document.documentElement.classList.add('static');
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  var CFG = {};
  try { CFG = JSON.parse(($('#mk-config') || {}).textContent || '{}'); } catch (e) { CFG = {}; }
  var ROUTES = CFG.routes || {};
  var ROOT = ROUTES.root || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';

  var track = function (name, detail) {
    try { document.dispatchEvent(new CustomEvent('analytics:' + name, { detail: detail || {} })); } catch (e) {}
  };

  /* ---------- pricing (preview only) ----------
     pouches 20 to 500g, tins 50 to 250g. A tin is the pouch price plus ₹100.
     The more you buy, the less each gram costs. */
  var PR = CFG.pricing || { POUCH: [20, 50, 100, 250, 500], TINS: [50, 100, 250], TIN: 100, RATE: { 20: 1.1, 50: 1, 100: .95, 250: .88, 500: .8 }, PLAN: { once: [1, 1], x3: [3, .9], x6: [6, .85] } };
  var POUCH = PR.POUCH, TINS = PR.TINS, TIN = PR.TIN, RATE = PR.RATE, PLAN = PR.PLAN;
  var nine = function (x) { return Math.max(29, Math.ceil(x / 10) * 10 - 1); };
  var priceAt = function (p100, g, fmt) { return nine(p100 * g / 100 * RATE[g]) + (fmt === 'tin' ? TIN : 0); };
  var saving = function (g) { return g >= 100 ? Math.round((1 - RATE[g]) * 100) : 0; };
  var planTotal = function (once, plan) { var p = PLAN[plan] || PLAN.once; return Math.round(once * p[0] * p[1]); };
  window.MKP = { POUCH: POUCH, TINS: TINS, TIN: TIN, RATE: RATE, PLAN: PLAN, nine: nine, price: priceAt, saving: saving, planTotal: planTotal };

  /* ₹ in the Indian grouping, whole rupees. money() takes Shopify cents. */
  var inr = function (n) { return '₹' + Math.round(n).toLocaleString('en-IN'); };
  var money = function (cents) { var r = cents / 100; return '₹' + r.toLocaleString('en-IN', { minimumFractionDigits: r % 1 ? 2 : 0, maximumFractionDigits: 2 }); };

  /* ---------- load-time animation gate ----------
     House rule: nothing animates at load (Chromium drops LCP when a never-ending animation runs).
     Infinite animations in maison.css wait for html.mk-live, set on the first interaction. */
  var goLive = function () {
    document.documentElement.classList.add('mk-live');
    ['pointerdown', 'keydown', 'touchstart', 'scroll', 'wheel'].forEach(function (t) { window.removeEventListener(t, goLive); });
  };
  ['pointerdown', 'keydown', 'touchstart', 'scroll', 'wheel'].forEach(function (t) { window.addEventListener(t, goLive, { passive: true }); });

  /* ---------- reveal ----------
     Only .rv elements below the first viewport are armed and fade in on scroll. Anything already on
     screen (or scrolled past) stays as rendered, so the first viewport never waits on this script. */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: .08, rootMargin: '0px 0px -40px 0px' }) : null;
  function reveal(scope) {
    if (!io || reduce || document.documentElement.classList.contains('static')) return;
    var vh = window.innerHeight;
    $$('.rv:not(.rv-armed):not(.in)', scope).forEach(function (el) {
      if (el.getBoundingClientRect().top < vh) return;
      el.classList.add('rv-armed');
      io.observe(el);
    });
  }
  reveal(document);
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });

  /* ---------- header ----------
     On the homepage the header sits over the hero and turns solid once the hero is behind it.
     Every other page renders it solid from Liquid. */
  var header = $('#header');
  var syncHeader = function () {
    var hero = $('.hero');
    if (!header || !hero || document.body.classList.contains('inner')) return;
    header.classList.toggle('solid', hero.getBoundingClientRect().bottom < 90);
  };
  window.addEventListener('scroll', syncHeader, { passive: true }); syncHeader();
  document.addEventListener('shopify:section:load', function () { header = $('#header'); syncHeader(); });

  /* ---------- mobile menu ---------- */
  var openMenu = function (on) {
    var nav = $('#mnav'); if (!nav) return;
    document.body.classList.toggle('menu-open', on); nav.setAttribute('aria-hidden', !on);
    if ('inert' in nav) nav.inert = !on;
    var btn = $('#menuBtn'); if (btn) btn.setAttribute('aria-expanded', on);
    if (on) { var c = $('#menuClose'); if (c) c.focus(); } else if (btn && nav.contains(document.activeElement)) btn.focus();
  };
  document.addEventListener('click', function (e) {
    if (e.target.closest('#menuBtn')) openMenu(true);
    else if (e.target.closest('#menuClose') || e.target.closest('#mnav a')) openMenu(false);
  });

  /* ---------- WhatsApp: number halves are base64 data attributes, assembled on click (scraper-proof) ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-wa-a]'); if (!a) return;
    e.preventDefault();
    track('generate_lead', { source: a.dataset.waSource || 'whatsapp_click' });
    try {
      var n = atob(a.dataset.waA) + atob(a.dataset.waB), t = a.dataset.waText;
      window.open('https://wa.me/' + n + (t ? '?text=' + encodeURIComponent(t) : ''), '_blank', 'noopener');
    } catch (err) {}
  });

  /* ---------- bag: the Shopify cart drawer (sections/cart-drawer.liquid) ---------- */
  var post = function (url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { var err = new Error(j.description || j.message || 'cart_error'); err.status = r.status; err.data = j; throw err; } return j; }); });
  };
  var url = function (k, fallback) { return (ROUTES[k] || fallback) + '.js'; };
  var drawer = function () { return $('cart-drawer'); };

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', class extends HTMLElement {
      connectedCallback() {
        this._click = this._click.bind(this);
        this._change = this._change.bind(this);
        this._input = this._input.bind(this);
        this._submit = this._submit.bind(this);
        this._key = this._key.bind(this);
        this.addEventListener('click', this._click);
        this.addEventListener('change', this._change);
        this.addEventListener('input', this._input);
        this.addEventListener('submit', this._submit);
        document.addEventListener('keydown', this._key);
        this._sync();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this._click);
        this.removeEventListener('change', this._change);
        this.removeEventListener('input', this._input);
        this.removeEventListener('submit', this._submit);
        document.removeEventListener('keydown', this._key);
        clearTimeout(this._noteTimer);
        document.body.classList.remove('bag-open');
      }
      get panel() { return this.querySelector('.drawer'); }
      isOpen() { return document.body.classList.contains('bag-open'); }
      open(opts) {
        if (!this.isOpen()) this._lastFocus = document.activeElement;
        document.body.classList.add('bag-open');
        var p = this.panel; if (p) { p.setAttribute('aria-hidden', 'false'); if ('inert' in p) p.inert = false; p.focus({ preventScroll: true }); }
        if (opts && opts.fromAdd) return;  /* add_to_cart already covers it */
        fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          track('view_cart', { value: cart.total_price / 100, items: cart.items.map(function (i) { return { item_id: i.product_id, variant_id: i.variant_id, quantity: i.quantity, price: i.price / 100 }; }) });
        }).catch(function () {});
      }
      close() {
        if (!this.isOpen()) return;
        document.body.classList.remove('bag-open');
        var p = this.panel; if (p) { p.setAttribute('aria-hidden', 'true'); if ('inert' in p) p.inert = true; }
        if (this._lastFocus && this._lastFocus.focus) this._lastFocus.focus();
      }
      _sync() {
        var p = this.panel; if (!p) return;
        var on = this.isOpen();
        p.setAttribute('aria-hidden', on ? 'false' : 'true');
        if ('inert' in p) p.inert = !on;
        var g = this.querySelector('[data-gift-on]'), box = this.querySelector('[data-gift-box]'), note = this.querySelector('[data-gift-note]');
        if (g && box) { box.hidden = !g.checked; if (note) note.disabled = !g.checked; }
      }
      _key(e) {
        if (e.key === 'Escape' && this.isOpen()) this.close();
        if (e.key === 'Tab' && this.isOpen()) {  /* keep focus inside the open bag */
          var f = $$('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex="0"]', this.panel);
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      }
      _click(e) {
        if (e.target.closest('[data-bag-close]')) { e.preventDefault(); this.close(); return; }
        var step = e.target.closest('[data-line-step]');
        if (step) {
          e.preventDefault();
          var cur = +step.dataset.qty, next = Math.max(0, cur + +step.dataset.lineStep);
          this._line(step.dataset.key, next, cur, step);
          return;
        }
        var rm = e.target.closest('[data-line-remove]');
        if (rm) { e.preventDefault(); this._line(rm.dataset.key, 0, +rm.dataset.qty, rm); }
      }
      _line(key, qty, prev, btn) {
        var self = this;
        this.setAttribute('aria-busy', 'true');
        if (btn) btn.disabled = true;
        return post(url('cartChange', ROOT + 'cart/change'), { id: key, quantity: qty }).then(function () {
          if (qty < prev) track('remove_from_cart', { item_key: key, quantity_removed: prev - qty });
          return self.refresh();
        }).catch(function () { if (btn) btn.disabled = false; }).then(function () { self.removeAttribute('aria-busy'); });
      }
      _change(e) {
        if (e.target.matches('[data-gift-on]')) {
          clearTimeout(this._noteTimer);  /* a pending note save would set gift=Yes again */
          this._noteTimer = null;
          this._sync();
          var on = e.target.checked, note = this.querySelector('[data-gift-note]');
          this._saveGift(on, on && note ? note.value : '');
          if (on && note) note.focus();
        }
      }
      _input(e) {
        if (!e.target.matches('[data-gift-note]')) return;
        var self = this, v = e.target.value;
        clearTimeout(this._noteTimer);
        this._noteTimer = setTimeout(function () { self._noteTimer = null; self._saveGift(true, v); }, 500);
      }
      _saveGift(on, note) {
        this._pending = post(url('cartUpdate', ROOT + 'cart/update'), { attributes: { gift: on ? 'Yes' : '' }, note: note || '' }).catch(function () {});
        return this._pending;
      }
      _submit(e) {
        var form = e.target.closest('[data-bag-form]'); if (!form) return;
        /* the form posts note + attributes[gift] natively, so nothing typed is lost even mid-save */
        clearTimeout(this._noteTimer);
        track('begin_checkout', {});
      }
      refresh() {
        var self = this;
        /* flush a pending note save first, so the fresh markup carries what was typed */
        var flush = Promise.resolve();
        if (this._noteTimer) {
          clearTimeout(this._noteTimer); this._noteTimer = null;
          var g0 = this.querySelector('[data-gift-on]'), n0 = this.querySelector('[data-gift-note]');
          if (g0 && g0.checked && n0) flush = this._saveGift(true, n0.value);
        }
        return flush.then(function () { return fetch(ROOT + '?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } }); })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('cart-drawer');
            if (!fresh) return;
            var active = document.activeElement && self.contains(document.activeElement) ? document.activeElement.getAttribute('data-focus-id') : null;
            /* still typing in the gift note: carry its text, the gift tick and the caret across the swap */
            var note = self.querySelector('[data-gift-note]'), gift = self.querySelector('[data-gift-on]'), keep = null;
            if (note && document.activeElement === note) keep = { v: note.value, on: gift ? gift.checked : true, a: note.selectionStart, b: note.selectionEnd };
            self.innerHTML = fresh.innerHTML;
            if (keep) {
              var n2 = self.querySelector('[data-gift-note]'), g2 = self.querySelector('[data-gift-on]');
              if (g2) g2.checked = keep.on;
              if (n2) n2.value = keep.v;
            }
            self._sync();
            if (self.isOpen()) {
              var p = self.panel, back = active && self.querySelector('[data-focus-id="' + active + '"]');
              (back || p).focus({ preventScroll: true });
            }
            if (keep) {
              var n3 = self.querySelector('[data-gift-note]');
              if (n3 && !n3.disabled) { n3.focus({ preventScroll: true }); try { n3.setSelectionRange(keep.a, keep.b); } catch (e) {} }
            }
            var count = +fresh.getAttribute('data-count') || 0;
            $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.classList.toggle('on', count > 0); });
            document.dispatchEvent(new CustomEvent('mk:cart-updated', { detail: { count: count } }));
          }).catch(function () {});
      }
    });
  }

  /* MKBag.add(items, opts)
     items: one item or an array of { id: variantId, quantity, properties }
     opts:  { open: true (default), source: 'product_card', analytics: {extra detail} | false }
     Resolves with the /cart/add.js response; rejects with an Error carrying Shopify's description. */
  window.MKBag = {
    add: function (items, opts) {
      opts = opts || {};
      items = [].concat(items).map(function (i) {
        var o = { id: Number(i.id), quantity: Number(i.quantity || 1) };
        if (i.properties) o.properties = i.properties;
        if (i.selling_plan) o.selling_plan = i.selling_plan;
        return o;
      });
      return post(url('cartAdd', ROOT + 'cart/add'), { items: items }).then(function (res) {
        if (opts.analytics !== false) {
          var added = res.items || [res];
          /* the response carries the merged line quantity; report what was asked for (items match by index) */
          added.forEach(function (it, k) {
            var q = items[k] ? items[k].quantity : it.quantity;
            track('add_to_cart', Object.assign({ item_id: it.product_id, item_name: it.product_title, variant_id: it.variant_id, price: it.price / 100, quantity: q, value: it.price * q / 100, source: opts.source || 'bag' }, opts.analytics || {}));
          });
        }
        var d = drawer();
        return (d ? d.refresh() : Promise.resolve()).then(function () { if (d && opts.open !== false) d.open({ fromAdd: true }); return res; });
      });
    },
    open: function () { var d = drawer(); if (d) d.open(); },
    close: function () { var d = drawer(); if (d) d.close(); },
    refresh: function () { var d = drawer(); return d ? d.refresh() : Promise.resolve(); },
    gift: function (on) {
      var d = drawer(), g = d && d.querySelector('[data-gift-on]');
      if (g) { g.checked = !!on; g.dispatchEvent(new Event('change', { bubbles: true })); }
    }
  };

  /* openers: header bag button and any [data-open-cart-drawer] */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('#bagBtn, [data-open-cart-drawer]')) return;
    e.preventDefault(); window.MKBag.open();
  });

  /* add-to-bag forms (product cards and anything with [data-mk-add]): a real /cart/add form,
     upgraded to AJAX. Without JS it posts natively and Shopify's /cart bounces back to the drawer. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-mk-add]'); if (!form || !drawer()) return;
    e.preventDefault();
    var fd = new FormData(form), item = { id: fd.get('id'), quantity: fd.get('quantity') || 1 }, props = {};
    fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v !== '') props[m[1]] = v; });
    if (Object.keys(props).length) item.properties = props;
    var btn = form.querySelector('[type="submit"]'), card = form.closest('[data-product-id]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    window.MKBag.add(item, {
      source: form.dataset.mkAdd || 'product_card',
      analytics: card ? { item_id: Number(card.dataset.productId), item_name: card.dataset.productTitle } : {}
    }).catch(function (err) {
      var msg = form.querySelector('[data-add-error]');
      if (msg) { msg.textContent = err.message; msg.hidden = false; } else form.submit();
    }).then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });

  /* select_item when a card link is followed */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-product-id] a[href]'); if (!a) return;
    var card = a.closest('[data-product-id]');
    track('select_item', { item_id: Number(card.dataset.productId), item_name: card.dataset.productTitle });
  });

  /* the /cart template sets this flag and bounces back here, so the drawer opens over the page */
  try { if (sessionStorage.getItem('open-cart-drawer')) { sessionStorage.removeItem('open-cart-drawer'); window.MKBag.open(); } } catch (e) {}

  window.MK = Object.assign(window.MK || {}, { $: $, $$: $$, esc: esc, inr: inr, money: money, config: CFG, reveal: reveal, track: track });
})();
